import { render, staticRenderFns } from "./orderHeader.vue?vue&type=template&id=1a4edab4&scoped=true&"
import script from "./orderHeader.vue?vue&type=script&lang=js&"
export * from "./orderHeader.vue?vue&type=script&lang=js&"
import style0 from "./orderHeader.vue?vue&type=style&index=0&id=1a4edab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4edab4",
  null
  
)

export default component.exports